// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__0iqRY","faq-content":"Faq_faq-content__LQ_MW"};